
import { useTranslation } from 'react-i18next'
import Logo  from '../../assets/rasun/logo.png'
import XImg  from "../../assets/rasun/x.png"
import TgImg  from "../../assets/rasun/tg.png"
import DisImg  from "../../assets/rasun/dis.png"

export default function Footer() {
    const { t } = useTranslation()

    return (
        <>
            <div className='w-full  pt-12 mt-10    bottom-0 z-30  flex flex-col items-center border-t border-t-stone-900' >



                <div className="w-full px-4 h-6 flex felx-row justify-center items-center">
                    <img  alt='rr' className='mr-1' src={Logo} style={{"width":"30px"}}></img>
                    <span className=' text-base text-gray-200'>VRP DAO</span>

                </div>

                <div className="w-full mt-2 px-4 h-12 flex felx-row justify-center items-center">

                    <img   alt='rr' className='mr-5' src={XImg} style={{"width":"20px"}}></img>
                    <img   alt='rr' className='mr-5' src={TgImg} style={{"width":"20px"}}></img>
                    <img   alt='rr' className='' src={DisImg} style={{"width":"20px"}}></img>

                </div>

                <div className="w-full  px-4 h-5 flex felx-row justify-center items-center">

                    <span className=' text-xs text-stone-600' >ALL RIGHTS RESERVED @2026 VRP DAO</span>

                </div>

                <div className=' h-2'></div>

            </div>
        </>
    )
}